import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'byProductId'
})
export class ByProductIdPipe implements PipeTransform {

    transform(lines: any[], productId: Number): any {
        if (!lines || !productId) {
            return lines;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return lines.filter(item => item.article.produit.id === productId);
    }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/byProductId.pipe.ts